import { useState } from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1768337099525-1f2b4c872381?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxyYXJlJTIwZ29sZCUyMGNvaW4lMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODE3Mzc2MDF8MA&ixlib=rb-4.1.0&q=85";

const CoinCard = ({ coin, span = "col-span-1 md:col-span-4" }) => {
  const gallery = (coin.images && coin.images.length)
    ? coin.images.map(fileUrl)
    : (coin.image_url ? [fileUrl(coin.image_url)] : [FALLBACK]);
  const [active, setActive] = useState(0);
  const img = gallery[active] || gallery[0];

  return (
    <Link
      to={`/coin/${coin.id}`}
      className={`group relative overflow-hidden bg-[#0A0A0A] border border-[#F3EFE0]/5 hover:border-[#D4AF37]/40 hover:bg-[#121212] transition-all duration-500 ease-out p-8 flex flex-col ${span}`}
      data-testid={`coin-card-${coin.id}`}
    >
      <div className="relative aspect-square w-full mb-6 overflow-hidden">
        <img
          src={img}
          alt={coin.name}
          className="w-full h-full object-contain opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out"
          loading="lazy"
        />
        {coin.sold && (
          <div className="absolute top-2 right-2 coin-tag bg-[#5C2B29]/80 text-[#F3EFE0] px-2 py-1 backdrop-blur-sm">Sold</div>
        )}
        {coin.featured && !coin.sold && (
          <div className="absolute top-2 left-2 coin-tag bg-[#D4AF37]/15 text-[#D4AF37] px-2 py-1 backdrop-blur-sm">Featured</div>
        )}
        {gallery.length > 1 && (
          <div className="absolute bottom-2 right-2 coin-tag bg-black/60 text-[#F3EFE0] px-2 py-1 backdrop-blur-sm" data-testid={`coin-card-photo-count-${coin.id}`}>
            {gallery.length} photos
          </div>
        )}
      </div>

      {gallery.length > 1 && (
        <div className="flex flex-wrap gap-2 mb-5" data-testid={`coin-card-thumbs-${coin.id}`}>
          {gallery.slice(0, 5).map((g, i) => (
            <button
              key={g + i}
              type="button"
              onMouseEnter={() => setActive(i)}
              onClick={(e) => { e.preventDefault(); setActive(i); }}
              className={`w-12 h-12 bg-black border p-0.5 transition-colors ${i === active ? "border-[#D4AF37]" : "border-[#F3EFE0]/10 hover:border-[#F3EFE0]/30"}`}
              data-testid={`coin-card-thumb-${coin.id}-${i}`}
              aria-label={`View image ${i + 1}`}
            >
              <img src={g} alt={`${coin.name} view ${i + 1}`} className="w-full h-full object-contain" loading="lazy" />
            </button>
          ))}
        </div>
      )}

      <div className="flex flex-col flex-1">
        <div className="coin-tag mb-2 text-[#6B6A65]">{coin.era || coin.metal || "Numismatic"}</div>
        <h3 className="font-display text-2xl text-[#F3EFE0] leading-tight mb-3 group-hover:text-[#D4AF37] transition-colors">{coin.name}</h3>
        <p className="text-sm text-[#A19D94] line-clamp-2 mb-6 flex-1">{coin.description}</p>
        <div className="flex items-end justify-between border-t border-[#F3EFE0]/5 pt-4">
          <div>
            <div className="coin-tag text-[#6B6A65]">Price</div>
            <div className="font-mono text-[#D4AF37] text-lg">${Number(coin.price).toLocaleString()}</div>
          </div>
          <span className="coin-tag text-[#A19D94] group-hover:text-[#D4AF37] transition-colors">View →</span>
        </div>
      </div>
    </Link>
  );
};

export default CoinCard;
